// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AutoHideController from "./auto_hide_controller"
application.register("auto-hide", AutoHideController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import EditableColumnController from "./editable_column_controller"
application.register("editable-column", EditableColumnController)

import FilterResetController from "./filter_reset_controller"
application.register("filter-reset", FilterResetController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImagePreviewController from "./image_preview_controller"
application.register("image_preview", ImagePreviewController)

import LoaderIndicatorController from "./loader_indicator_controller"
application.register("loader-indicator", LoaderIndicatorController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MobileSidebarController from "./mobile_sidebar_controller"
application.register("mobile-sidebar", MobileSidebarController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import ProfilePreviewController from "./profile_preview_controller"
application.register("profile-preview", ProfilePreviewController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SnapshotDrawingController from "./snapshot_drawing_controller"
application.register("snapshot-drawing", SnapshotDrawingController)

import ToggleButtonController from "./toggle_button_controller"
application.register("toggle-button", ToggleButtonController)

import VisibilityControlController from "./visibility_control_controller"
application.register("visibility-control", VisibilityControlController)
